// Navigation targets from the Scheduled Reports page to the Analytics report
// (DEV-2377). "Manage" opens the report with its schedule drawer (canvas-header
// reads ?drawer=schedule); "New report" opens the add-view form (?view=new) and
// deliberately does NOT open the schedule drawer.

const analyticsReportPath = (accountId: string, assetId: string) =>
	`/workspace/${accountId}/asset/${assetId}/analytics-reports`

// `viewId` loads the schedule's own view first (canvas-header reads ?view=<id>),
// so the drawer opens on the report the schedule belongs to — not on whichever
// view happened to be active.
export const buildManageTarget = (accountId: string, assetId: string, viewId?: string) =>
	`${analyticsReportPath(accountId, assetId)}?drawer=schedule${
		viewId ? `&view=${encodeURIComponent(viewId)}` : ''
	}`

export const buildCreateTarget = (accountId: string, assetId: string) =>
	`${analyticsReportPath(accountId, assetId)}?view=new`
